import { all, call, put, takeLatest } from 'redux-saga/effects'
import DraftActions, { DraftTypes } from 'Redux/DraftRedux'

// Save Draft Segments
export function* saveDraft(api, action) {
  try {
    const { scriptId, audioUrl, segments, options } = action
    const { subtitlesEnabled = false, subtitleSettings = null, soundEffectClips = [] } = options || {}
    
    const params = {
      audio_url: audioUrl,
      subtitles_enabled: subtitlesEnabled,
      subtitle_settings: subtitleSettings,
      segments: segments.map(seg => ({
        id: seg.id,
        thumbnail_image_id: seg.thumbnail_image_id || seg.id,
        image_url: seg.image_url,
        prompt: seg.prompt || '',
        animated_video_url: seg.animated_video_url || null,
        animation_status: seg.animation_status || null,
        animation_prompt: seg.animation_prompt || '',
        start_time: seg.startTime,
        end_time: seg.endTime,
      })),
      sound_effect_clips: soundEffectClips.map(clip => ({
        provider_sound_id: clip.asset?.provider_sound_id || clip.provider_sound_id,
        name: clip.asset?.name || clip.name,
        preview_url: clip.asset?.preview_url || clip.preview_url,
        audio_url: clip.asset?.audio_url || clip.audio_url,
        duration: clip.asset?.duration || clip.duration,
        category: clip.asset?.category || clip.category,
        start_time: clip.start_time,
        end_time: clip.end_time,
        loop_enabled: clip.loop_enabled,
        volume: clip.volume,
        layer_index: clip.layer_index || 0,
      })),
    }

    const resp = yield call(api.saveDraftSegments, scriptId, params)

    if (resp.ok) {
      yield put(DraftActions.draftSaveSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to save draft'
      yield put(DraftActions.draftSaveFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to save draft'
    yield put(DraftActions.draftSaveFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Get Draft Segments
export function* getDraft(api, action) {
  try {
    const resp = yield call(api.getDraftSegments, action.scriptId)

    if (resp.ok) {
      yield put(DraftActions.draftGetSuccess(resp.data))
      if (action.callback) {
        action.callback(resp.data, null)
      }
    } else if (resp.status === 404) {
      // No draft exists, which is fine
      yield put(DraftActions.draftGetSuccess(null))
      if (action.callback) {
        action.callback(null, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to get draft'
      yield put(DraftActions.draftGetFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to get draft'
    yield put(DraftActions.draftGetFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Delete Draft Segments
export function* deleteDraft(api, action) {
  try {
    const resp = yield call(api.deleteDraftSegments, action.scriptId)

    if (resp.ok || resp.status === 404) {
      yield put(DraftActions.draftDeleteSuccess())
      if (action.callback) {
        action.callback(true, null)
      }
    } else {
      const error = resp.data?.error || 'Failed to delete draft'
      yield put(DraftActions.draftDeleteFailure(error))
      if (action.callback) {
        action.callback(null, error)
      }
    }
  } catch (error) {
    const errorMsg = error.message || 'Failed to delete draft'
    yield put(DraftActions.draftDeleteFailure(errorMsg))
    if (action.callback) {
      action.callback(null, errorMsg)
    }
  }
}

// Watcher saga
export default function* draftSaga(api) {
  yield all([
    takeLatest(DraftTypes.DRAFT_SAVE_REQUEST, saveDraft, api),
    takeLatest(DraftTypes.DRAFT_GET_REQUEST, getDraft, api),
    takeLatest(DraftTypes.DRAFT_DELETE_REQUEST, deleteDraft, api),
  ])
}
